export default "__VITE_ASSET__DC7H4pdi__"